import { render, staticRenderFns } from "./DetailInfoModal.vue?vue&type=template&id=68c38287&"
import script from "./DetailInfoModal.vue?vue&type=script&lang=js&"
export * from "./DetailInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailInfoModal.vue?vue&type=style&index=0&id=68c38287&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports